import React from 'react';
import 'react-mde/lib/styles/css/react-mde-all.css';
import { CustomPage } from '../../components/customPage';


export const Faq: React.FC = () => {
  return (
    <CustomPage>FAQ</CustomPage>
  );
}